module.exports = __webpack_public_path__ + "media/application/images/ui/dropdown-1d4f23e6f95927e2fdd42b11aad22423.png";